import { render, staticRenderFns } from "./notice-manage.vue?vue&type=template&id=81310a20&"
import script from "./notice-manage.vue?vue&type=script&lang=js&"
export * from "./notice-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports